import { memo } from 'react';
import { useTranslation } from 'react-i18next';

type LangsPropsType = Partial<Record<'title' | 'prefixKey', string>>;

const LangsComponent = ({ title = '', prefixKey = 'develop_prefix_' }: LangsPropsType) => {
  const { t } = useTranslation();
  return <>{t(prefixKey + title)}</>;
};

export const Langs = memo(LangsComponent);
